<template>
  <v-flex 
    xs12 
    style="border: 2px solid #000;" 
    pa-0
    my-2
    class="text-xs-left" 
  >
    <v-layout>
      <v-flex v-if="!loading">

        <v-layout row pa-0 ma-0 align-center fill-height style="position: relative;">

          <div style="position: absolute; top: 0px; bottom: 0px; left: 0px; width: 110px; z-index: 0;" class="primary"></div>

          <v-flex style="min-width: 110px; z-index: 1;" class="white--text text-xs-center" shrink>
            
            <h2 class="ma-0 pa-0">{{ $moment(trip.checkin_date).format("DD") }}</h2>
            <div>{{ $moment(trip.checkin_date).format("MMM YYYY") }}</div>
                
          </v-flex>
          <!--<div style="position: absolute; top: 0; margin: 0 auto; left: 0; right: 0;" class="pa-2 text-xs-center">
            <strong>{{trip.location_city}}</strong> on <strong>{{ $moment(trip.checkin_date).format("L") }}</strong>
          </div>
          <div style="position: absolute; top: 0; right: 0;" class="pa-2">
            <a style="text-decoration: none;" @click="confirmCancelTrip(trip)">Cancel Trip</a>
          </div>-->
          
          <v-flex class="text-xs-left ma-0 pa-0" style="position: relative;">
            <div style="position: absolute; top: 0px; left: 0px; right: 0px;" class="px-3 py-2">
              <strong>{{trip.travel_location_city}}, {{trip.travel_location_state}}</strong>
            </div>

            <v-layout :row="$vuetify.breakpoint.mdAndUp" :column="$vuetify.breakpoint.smAndDown" fill-height align-center>
              <v-flex pa-3 :mt-2="$vuetify.breakpoint.mdAndUp" :mt-3="$vuetify.breakpoint.smAndDown" :style="{'width':($vuetify.breakpoint.smAndDown ? '100%' : 'auto')}">
                <div style="font-size: 1.2em;" class="my-3">{{ tripSummary().title }}</div>
                <v-layout row wrap v-if="selected.length">
                  <v-flex xs6 sm3 md2
                    v-for="(inv) in selected"
                    :key="trip.id + '-i-' + inv.id">
                    <inventory-item 
                      :item="inv" 
                      condensed
                      ignore-availability
                      :show-buy="showBuy(inv)"
                      :buy-now-unavailable="buyNowUnavailable(inv)"
                      :show-owned="(owned(inv) ? true : false)"
                      @on-buy-now="$emit('on-buy-now', {trip: trip, inventory: inv})"
                      @on-owned="$emit('on-owned', {inventory: inv, trip: trip, lookbook: trip.lookbook, order: owned(inv)})"
                    ></inventory-item>  
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex style="min-width: 200px; max-width: 200px;" class="text-xs-center pa-2" shrink>
                <v-btn small block color="primary" :to="tripUrl">{{ tripSummary().button }}</v-btn>
                <a style="text-decoration: none;" @click="confirmCancelTrip()" v-if="canCancel">Cancel Trip</a>
              </v-flex>
            </v-layout>
          </v-flex>
          
        </v-layout>

      </v-flex>
      <v-flex v-else class="pa-4">
        <div class="spinner my-0">
          <div class="double-bounce1"></div>
          <div class="double-bounce2"></div>
        </div>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import InventoryItem from '@/components/helpers/InventoryItem';

export default {
  name: 'TripSummary',
  props: {
    'trip': Object,
    'current': Boolean
  },
  components: {
    'inventory-item': InventoryItem
  },
  data () {
    return {
      selections: [],
    }
  },
  mounted: function() {
    
  },
  computed: {
    cdn: function() {
      return this.$root.cdn;
    },
    loading: function() {
      //if(!this.trip.lookbook || !this.trip.order) return true;
      return false;
    },
    tripUrl: function() {
      let url = {
        name: 'trip',
        params: {id: this.trip.id}
      }
      if(this.tripStatus() == 'need_review') {
        url.query = {review: 1}
      }
      return url;
    },
    inventory: function() {
      let arr = [];
      if(!this.trip || !this.trip.order || !this.trip.order.orderInventory) return arr;

      for(let i = 0; i < this.trip.order.orderInventory.length; i++) {
        let inv_id = this.trip.order.orderInventory[i].inventory_id;
        let sel_id = this.trip.order.orderInventory[i].variation_id;
        for(let i2 = 0; i2 < this.trip.order.inventory.length; i2++) {
          let inv = JSON.parse(JSON.stringify(this.trip.order.inventory[i2]));
          if(this.trip.order.inventory[i2].id == inv_id) {
            inv.recommended = sel_id;
            inv.selected = sel_id;
            inv.purchased = this.trip.order.orderInventory[i].purchaseOrder;
            arr.push(inv);
          }
        }
      }
      return arr;
    },
    selected: function() {
      let items = [];
      for(let i = 0; i < this.inventory.length; i++) {
        if(this.inventory[i].selected) items.push(this.inventory[i]);
      }
      return items;
    },
    canCancel: function() {
      return (!this.trip.order || this.trip.order.status == 'PENDING')
    }
  },
  methods: {
    confirmCancelTrip: function() {
      let trip = this.trip;
      this.$swal.fire({
        title: 'Cancel this Trip?',
        text: 'Are you sure you want to cancel this trip?',
        confirmButtonText: 'Yes, Cancel It',
        cancelButtonText: 'No'
      }).then(result => {
        if(result.value) {
          this.$http.post('trips/' + trip.id + '/cancel')
            .then(response => {
              this.$emit('on-cancelled', trip.id);
            })
            .catch(error => {
              this.$swal.fire({
                title: 'An Error Occurred',
                text: 'There was an error cancelling your trip. Please try again.'
              });
            });
        }
      })
    },
    tripStatus: function() {
      let trip = this.trip;

      if(trip.order && trip.order.status == 'COMPLETE') {
        if(trip.checkin_date <= this.$moment().format('YYYY-MM-DD') && trip.checkout_date >= this.$moment().format('YYYY-MM-DD')) {
          return 'in_progress';
        } else if(trip.checkout_date < this.$moment().format('YYYY-MM-DD')) {
          if(!trip.review_id) {
            return 'need_review';
          } else {
            return 'complete';
          }
        }
      }

      if(!trip.lookbook || trip.lookbook.status == 'PREPARING') {
        let earlyDate = this.$moment().add(7, 'days');
        let laterDate = this.$moment().add(10, 'days');

        if(
          this.$moment(trip.checkin_date).isSameOrAfter(earlyDate, 'day') &&
          this.$moment(trip.checkin_date).isSameOrBefore(laterDate, 'day')
        ) {
          return 'pending_urgent';
        } else {
          return 'pending';
        }
      }
      if(trip.lookbook.status == 'ADDITIONAL_REQUESTED') {
        return 'waiting_for_additional';
      }
      if(trip.lookbook.status == 'READY') {
        if(!this.selected || this.selected.length < 2) {
          return 'waiting_for_selections';
        }
        if(!trip.order || trip.order.status == 'PENDING') {
          return 'waiting_for_order';
        }
        if(trip.order.status == 'PROCESSING') {
          return 'order_processing';
        }
        if(!trip.order.tracking_number || trip.order.tracking_number == '') {
          return 'waiting_for_shipping';
        }
        return 'order_shipped';
      }
    },
    tripSummary: function() {
      let trip = this.trip;
      //Pending
      if(this.tripStatus(trip) == 'pending') {
        return {
          title: "We’ve got your boarding pass to personal style! You'll be notified to review your Lookbook 10 days before your trip.",
          button: "EDIT TRIP"
        }
      }
      if(this.tripStatus(trip) == 'pending_urgent') {
        return {
          title: "A stylist is curating the perfect looks for your upcoming trip. You'll be notified to review your Lookbook within 24 hours!",
          button: "EDIT TRIP"
        }
      }
      if(this.tripStatus(trip) == 'waiting_for_additional') {
        return {
          title: "Your request for additional options is being looked at by a stylist. You will receive a notification once your Lookbook has been updated.",
          button: "EDIT TRIP"
        }
      }
      if(this.tripStatus(trip) == 'waiting_for_selections') {
        return {
          title: "Your Lookbook is Ready! Please make your selections.",
          button: "CHOOSE YOUR OUTFIT"
        }
      }
      if(this.tripStatus(trip) == 'waiting_for_order') {
        return {
          title: "Finish your order now to secure your favorite items",
          button: "FINISH ORDER"
        }
      }
      if(this.tripStatus(trip) == 'order_processing') {
        return {
          title: "Your order is being processed",
          button: "VIEW ORDER"
        }
      }
      if(this.tripStatus(trip) == 'waiting_for_shipping') {
        return {
          title: "Your travel wardrobe is being packed and prepared to ship!",
          button: "VIEW ORDER"
        }
      }
      if(this.tripStatus(trip) == 'order_shipped') {
        return {
          title: "Your items have shipped and will be waiting for you at your destination!",
          button: "VIEW ORDER"
        }
      }
      if(this.tripStatus(trip) == 'in_progress') {
        return {
          title: "Enjoy your travel wardrobe!",
          button: "VIEW ORDER"
        }
      }
      if(this.tripStatus(trip) == 'need_review') {
        return {
          title: "Please review your items to improve your next experience.",
          button: "REVIEW"
        }
      }
      if(this.tripStatus(trip) == 'complete') {
        return {
          title: "We hope you enjoyed your trip!",
          button: "VIEW ORDER"
        }
      }
      return {}
    },
    showBuy: function(inventory) {
      if(!this.trip || !this.trip.order || !this.trip.order.orderInventory) return false;
      if(this.trip.checkin_date <= this.$moment().format('YYYY-MM-DD')) {
        //Check if order is not returned too

        for(let i = 0; i < this.trip.order.orderInventory.length; i++) {
          let item = this.trip.order.orderInventory[i];
          if(item.inventory_id == inventory.id) {
            if(!item.purchaseOrder) return true;
          }
        }
      }
      
      return false;
    },
    buyNowUnavailable: function(inventory) {
      if(!inventory.selected) return true;
      for(let i = 0; i < inventory.variations.length; i++) {
        if(inventory.variations[i].id != inventory.selected) continue;
        if(inventory.variations[i].tp_purchase_price > 50) return false;
      }
      return true;
    },
    owned: function(inventory) {
      return false;
      /*let found = false;
      for(let i = 0; i < Object.keys(this.ordersForCurrent).length; i++) {
        let key = Object.keys(this.ordersForCurrent)[i];
        let order = this.ordersForCurrent[ key ];
        if(order.ord_type != 'buy') continue;
        if(order.trip_id != this.trip._id) continue;
        for(let i2 = 0; i2 < order.items.length; i2++ ) {
          if(order.items[ i2 ] == inventory._id) {
            found = order;
          } 
        }
      }

      return found;*/
    }
  }
}
</script>
